module.exports = __webpack_public_path__ + "img/胡萝卜.a3676b94.gif";